import React from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import classNames from 'classnames';

import CopyToClipboardButton from '../copy-to-clipboard-button';
import { ReactComponent as CopyIcon } from 'src/assets/icons/share/copy.svg';
import { ReactComponent as EmailIcon } from 'src/assets/icons/share/email.svg';
import { ReactComponent as FacebookIcon } from 'src/assets/icons/share/facebook.svg';
import { ReactComponent as TelegramIcon } from 'src/assets/icons/share/telegram.svg';
import { ReactComponent as TwitterIcon } from 'src/assets/icons/share/twitter.svg';
import { ReactComponent as WhatsappIcon } from 'src/assets/icons/share/whatsapp.svg';

import { LOCALES } from 'src/constants';
import type { ShareButtonConfigProps, ShareButtonProps, ShareButtonType } from 'src/interfaces';

import './share-button.scss';

const SHARE_BUTTONS: Record<ShareButtonType, ShareButtonConfigProps> = {
  copy: {
    label: LOCALES.COPY_URL,
    button: CopyToClipboardButton,
    icon: CopyIcon,
    color: '#808080',
  },
  email: { label: LOCALES.EMAIL, button: EmailShareButton, icon: EmailIcon, color: '#5e8377' },
  facebook: {
    label: 'Facebook',
    button: FacebookShareButton,
    icon: FacebookIcon,
    color: '#1877f2',
  },
  telegram: {
    label: 'Telegram',
    button: TelegramShareButton,
    icon: TelegramIcon,
    color: '#0088cc',
  },
  twitter: { label: 'Twitter', button: TwitterShareButton, icon: TwitterIcon, color: '#1da1f2' },
  whatsapp: {
    label: 'WhatsApp',
    button: WhatsappShareButton,
    icon: WhatsappIcon,
    color: '#25d366',
  },
};

function ShareButton({ title, type, url }: ShareButtonProps<ShareButtonType>) {
  const { button: Button, color, icon: Icon, label } = SHARE_BUTTONS[type];
  return (
    <div className={classNames('share-button', `share-button_${type}`)}>
      <Button url={url} title={title}>
        <div className="share-button__icon" style={{ backgroundColor: color }}>
          <Icon />
        </div>
      </Button>
      <div className="share-button__label">{label}</div>
    </div>
  );
}

export default ShareButton;
